module.exports = __webpack_public_path__ + "dataanalysestatic/img/golden-finger.7ad8ca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/golden-finger.png
// module id = ZrqY
// module chunks = 37